import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader"
import { ThemedText, ThemedView } from "@app/theme"
import { formatIndianCurrency } from "@app/utils/utility"
import { Platform, ScrollView } from "react-native"
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import Button from "@app/sharedComponents/Button/Button"
import ROUTE from "@app/navigationApp/routes"
import PleadegedAssetInfo from "../PleadgeMF/PleadegedAssetInfo"
import { STATUS } from "../PledgeHistory/PledgeHistory"
import ActionStepper from "@app/sharedComponents/ActionStepper/ActionStepper"
import { useState } from "react";
import NeedHelp from "@app/sharedComponents/NeedHelp/NeedHelp";
import { useAppSelector } from "@app/store/hooks";
import { PrivateStackParamList, BottomTabParamList } from "@app/navigationApp/types";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
dayjs.extend(customParseFormat);


type ScreenProps = NativeStackScreenProps<PrivateStackParamList & BottomTabParamList, 'PLEDGE_DETAILS'>



export const PledgeDetails = ({ navigation, route }: ScreenProps) => {
  const pendingRequestDetails = useAppSelector((state) => state.auth.pendingRequestDetails);
  const { assetList, isUnpledge , source} = route.params ?? {}
  const [showContactUs, setShowContactUs] = useState(false)
  const showHome = useAppSelector(state => state.platformParams.showHome);


  const handleDonePress = () => {
    if(source === 'PLEDGE_DETAILS') {
      navigation.goBack()
    } else if(source === 'CREDIT_LOADING' && showHome) {
      navigation.reset({
        index: 0,
        routes: [{ name: 'HOME' }],
      });
    }
    else {
    
      navigation.navigate(ROUTE.PLEDGE_HISTORY)
    }
  }




  const pledgeStatus = assetList?.status ?? pendingRequestDetails?.enhanceLimitRequestDetailsList[0]?.status
  const pledgedHistoryStatus = pledgeStatus === "SUCCESS" ? "RTAs notified" : pledgeStatus === "FAILED" ? "Rejected" : "In progress"
  type ThemeColorKeys = 'bg-fill-success' | 'bg-fill-error' | 'bg-fill-warning' | 'text-success' | 'text-error' | 'text-warning';

  let pledgedHistoryBackgroundColor: ThemeColorKeys;
  let pledgedHistoryTextColor: ThemeColorKeys;

  if (pledgeStatus === STATUS.SUCCESS) {
    pledgedHistoryBackgroundColor = 'bg-fill-success';
    pledgedHistoryTextColor = 'text-success';
  } else if (pledgeStatus === STATUS.FAILED) {
    pledgedHistoryBackgroundColor = 'bg-fill-error';
    pledgedHistoryTextColor = 'text-error';
  } else {
    pledgedHistoryBackgroundColor = 'bg-fill-warning';
    pledgedHistoryTextColor = 'text-warning';
  }


  let secondStepperStatus
  if (pledgeStatus === "SUCCESS") {
    secondStepperStatus = "COMPLETED"
  } else if (pledgeStatus === "FAILED") {
    secondStepperStatus = "FAILED"
  } else {
    secondStepperStatus = "IN_PROGRESS"
  }

  const secondStepperFailedText = "For more details contact support"
  const secondStepperOtherDescriptionText = "Your request is being processed for approval"
  const thirdStepperFailedText = "SEBI authorised RTAs (CAMS and KFintech) will be notified to remove pledge from your portfolio."
  const thirdStepperSuccessText = "SEBI authorised RTAs (CAMS and KFintech) have been notified. It may take them 4-5 business days to remove pledge."
  const thirdStepperInProgressText = "SEBI authorised RTAs (CAMS and KFintech) will be notified to remove pledge from your portfolio."


  const pendingForeclosureStepperData = [
    {
      "status": "COMPLETED",
      "verticalDisplayName": "Unpledge request submitted",
      "verticalDescription": `Placed by you at ${dayjs(assetList?.createdOn).format('h:mm A, Do MMM')}`,
      "order": 0,
      "highLightText": false
    },
    {
      "status": secondStepperStatus,
      "verticalDisplayName": pledgeStatus === "FAILED" ? "Unpledge request rejected" : "Unpledge request under approval",
      "verticalDescription": pledgeStatus === "FAILED" ? secondStepperFailedText : secondStepperOtherDescriptionText,
      "order": 1,
      "highLightText": pledgeStatus !== "SUCCESS"
    },
    {
      "status": pledgeStatus === "SUCCESS" ? "COMPLETED" : pledgeStatus === "FAILED" ? "FAILED" : "WHATEVER",
      "verticalDisplayName": "RTA(s) will remove pledge",
      "verticalDescription": pledgeStatus === "FAILED" ? thirdStepperFailedText : pledgeStatus === "SUCCESS" ? thirdStepperSuccessText : thirdStepperInProgressText,
      "order": 2,
      "doNotHighlightImage": true,
      "highLightText": pledgeStatus === "SUCCESS"
    },
  ]
  const successDateFromBackend = assetList?.updatedOn ? assetList?.updatedOn : pendingRequestDetails?.enhanceLimitRequestDetailsList[0]?.updatedOn
  const stepperData = [
    {
      "status": "COMPLETED",
      "verticalDisplayName": "Request placed successfully",
      "verticalDescription": `Placed on ${dayjs(assetList?.createdOn ?? pendingRequestDetails?.enhanceLimitRequestDetailsList[0]?.createdOn).format('h:mm A, Do MMM YYYY')}`,
      "order": 0,
      "highLightText": false
    },
    {
      "status": pledgeStatus === "SUCCESS" ? "COMPLETED" : "IN_PROGRESS",
      "verticalDisplayName": pledgeStatus === "SUCCESS" ? "Request processed" : "We’re processing your request",
      "verticalDescription": pledgeStatus === "SUCCESS" ? `Processed on ${dayjs(successDateFromBackend).format('h:mm A, Do MMM YYYY')}` : "It may take upto 2-3 business hours",
      "order": 1,
      "highLightText": false
    },
  ]




  const renderUnpledgeDetails = () => {
    return (
      <ThemedView flex={1} backgroundColor="bg-fill-primary">
        <PageHeaders label="Remove pledge" navigation={navigation} pageName={"pledgeDetails"} triggerOpen={showContactUs} setTriggerOpen={setShowContactUs} />
        <ScrollView  >
          <ThemedView>
            <ThemedView padding="lg">
              <ThemedText variant="h5s" color="text-primary">
                Request details
              </ThemedText>
              <ThemedView marginTop="lg" padding="lg" borderRadius="sm" borderWidth={1} borderColor="border-secondary" backgroundColor="bg-surface-primary">
                <ThemedView flexDirection="row" justifyContent="space-between">
                  <ThemedText variant="b3r">
                    Date of request
                  </ThemedText>
                  <ThemedText variant="b3r">
                    {dayjs(assetList?.createdOn).format('DD MMM, YYYY')}
                  </ThemedText>
                </ThemedView>
                <ThemedView marginTop="sm" flexDirection="row" justifyContent="space-between">
                  <ThemedText variant="b3r">
                    Portfilio value
                  </ThemedText>
                  <ThemedText variant="b3r">
                    {`₹${formatIndianCurrency(assetList?.totalValueOfUnpledgedAssets)}`}
                  </ThemedText>
                </ThemedView>

                <ThemedView marginTop="sm" flexDirection="row" justifyContent="space-between">
                  <ThemedText variant="b3r">
                    Status
                  </ThemedText>
                  <ThemedView backgroundColor={pledgedHistoryBackgroundColor} px="md" my="2xs" borderRadius="xs">
                    <ThemedText color={pledgedHistoryTextColor} variant="b4r">{pledgedHistoryStatus.toUpperCase()}</ThemedText>
                  </ThemedView>
                </ThemedView>

              </ThemedView>
            </ThemedView>

            {pledgeStatus === 'FAILED' && <ThemedView>
              <ThemedText style={{ alignSelf: 'center' }} variant="b3r">
                Have any queries? Contact us
              </ThemedText>

              <ThemedView m="lg">
                <Button type="SOLID" handlePress={() => {
                  setShowContactUs(true)
                }} label={"Contact us"}>

                </Button>
              </ThemedView>

            </ThemedView>}
            <ThemedView my="lg" backgroundColor="border-secondary" height={5} width="100%" />
            <ThemedText variant="h5s" color="text-primary" mx="lg" mb="lg">Request Status</ThemedText>
            <ThemedView padding="lg" pt="sm">
              {
                pendingForeclosureStepperData.map((item, index) => (<ActionStepper data={item} key={index} showBottomLeftLine={index < pendingForeclosureStepperData.length - 1} />))
              }
            </ThemedView>

            <ThemedView padding="lg" backgroundColor="bg-fill-primary">
              <ThemedText variant="h5s">
                List of unpledged MFs
              </ThemedText>
              <ThemedView
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
                marginTop="lg"
              >
                <ThemedText variant="b4r" color="text-secondary">
                  Mutual fund
                </ThemedText>
                <ThemedText variant="b4r" color="text-secondary">
                  Fund value
                </ThemedText>
              </ThemedView>
              <ThemedView
                height={1}
                backgroundColor="border-primary"
                width="100%"
                my="sm"
              />
              <ScrollView style={{ marginTop: 8 }}>
                {assetList?.collateralDetailList.map((assetList, index) => (
                  <PleadegedAssetInfo
                    key={index}
                    position={index}
                    asset={assetList}
                    isEdit={false}
                    onCheckboxPressed={() => {

                    }}
                    pledgedList={[]}
                    onEditAmountPressed={() => {

                    }}
                  />
                ))}
              </ScrollView>
            </ThemedView>
          </ThemedView>
        </ScrollView>

      </ThemedView>

    )
  }

  const renderEnhanceLimitDetails = () => {
    return (
      <ThemedView flex={1} backgroundColor="bg-surface-primary">
        <PageHeaders label="Pledge details" navigation={navigation} pageName={"pledgeDetails"} />
        <ThemedView borderRadius="sm" borderWidth={1} borderColor="border-secondary" margin="lg">
          <ThemedView padding="lg">
            <ThemedText variant="h5s">
              Request for additional credit limit
            </ThemedText>
            <ThemedView flexDirection="row">
              <ThemedText variant="l2" color="text-emphasis-secondary" my="2xs">₹</ThemedText>
              <ThemedText variant="l2" color="text-emphasis-secondary" my="2xs">{`${formatIndianCurrency(assetList?.additionalCreditLimit ?? pendingRequestDetails?.enhanceLimitRequestDetailsList[0]?.additionalCreditLimit)}`}</ThemedText>
            </ThemedView>
            <ThemedView marginTop="lg" padding="lg" borderRadius="sm" borderColor="border-secondary" backgroundColor="bg-fill-secondary">
              <ThemedView flexDirection="row" justifyContent="space-between">
                <ThemedText variant="b3r" color="text-primary">
                  Existing credit limit
                </ThemedText>
                <ThemedText variant="b3r" color="text-emphasis-secondary">
                  {`₹${formatIndianCurrency(assetList?.initialCreditLimit ?? pendingRequestDetails?.enhanceLimitRequestDetailsList[0]?.initialCreditLimit)}`}
                </ThemedText>
              </ThemedView>
              <ThemedView flexDirection="row" justifyContent="space-between" mt="sm">
                <ThemedText variant="b3r" color="text-primary">
                  Additional credit limit
                </ThemedText>
                <ThemedText variant="b3r" color="text-emphasis-secondary">
                  {`₹${formatIndianCurrency(assetList?.additionalCreditLimit ?? pendingRequestDetails?.enhanceLimitRequestDetailsList[0]?.additionalCreditLimit)}`}
                </ThemedText>
              </ThemedView>
              <ThemedView my="lg" backgroundColor="border-secondary" height={1} width="100%" />

              <ThemedView flexDirection="row" justifyContent="space-between">
                <ThemedText variant="b3s" color="text-primary" >
                  Updated credit limit
                </ThemedText>
                <ThemedText variant="b3r" color="text-emphasis-secondary">
                  {`₹${formatIndianCurrency(assetList?.updatedCreditLimit ?? pendingRequestDetails?.enhanceLimitRequestDetailsList[0]?.updatedCreditLimit)}`}
                </ThemedText>
              </ThemedView>

            </ThemedView>
          </ThemedView>
          <ThemedView my="lg" backgroundColor="border-secondary" height={2} width="100%" />
          <ThemedView padding="lg" pt="sm">
            {
              stepperData.map((item, index) => (<ActionStepper data={item} key={index} showBottomLeftLine={index < stepperData.length - 1} />))
            }
          </ThemedView>
        </ThemedView>
        <ThemedView p="lg" position="absolute" bottom={0} width={'100%'} backgroundColor="bg-fill-primary" borderTopWidth={1} borderColor="border-primary">

          <Button
            label={'Done'}
            buttonLoader={false}
            handlePress={handleDonePress}
          />
        </ThemedView>


      </ThemedView>
    )
  }


  return (
    <ThemedView flex={1}>
      {isUnpledge ? renderUnpledgeDetails() : renderEnhanceLimitDetails()}
    </ThemedView>
  )


}

export default PledgeDetails